let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2tdfP")).then(() => parcelRequire('2490M'));